import { render, staticRenderFns } from "./transformMsg.vue?vue&type=template&id=58f5d030&scoped=true"
import script from "./transformMsg.vue?vue&type=script&lang=js"
export * from "./transformMsg.vue?vue&type=script&lang=js"
import style0 from "./transformMsg.vue?vue&type=style&index=0&id=58f5d030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5d030",
  null
  
)

export default component.exports